import { createDeepEqualitySelector } from 'lib/utils/createDeepEqualitySelector';
import _get from 'lodash/get';
import moment from 'moment';
import 'moment-duration-format';
import { getActivitySetsByRef } from 'lib/selectors/getActivitySetsByRef';
import { getLatestActivitySetRef } from 'lib/selectors/getLatestActivitySetRef';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getMachine } from 'lib/selectors/getMachine';

const defaultLatestActivitySet = {};

const getLatestActivitySet = createDeepEqualitySelector(
  [
    getLatestActivitySetRef,
    getActivitySetsByRef,
    getPostLaborUpdatesOnNats,
    getCurrentLaborTicket,
    getMachine,
    (state) => {
      return state.workOrderManagement?.currentWorkOrderOp;
    },
  ],
  (
    latestActivitySetRef,
    activitySetsByRef,
    natsFlowEnabled,
    currentLaborTicket,
    machine,
    currentWorkOrderOp
  ) => {
    // In NATS mode, derive activity set from labor ticket
    if (natsFlowEnabled) {
      if (!currentLaborTicket) {
        return defaultLatestActivitySet;
      }

      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      const isOpen =
        currentLaborTicket.state === 'OPEN' || endBehavior === 'keep-open';

      // Use cycleTimeMs from currentWorkOrderOp for duration calculations
      const cycleTimeMs = currentWorkOrderOp?.cycleTimeMs || 0;
      // Format as duration string (HH:mm:ss.SSS) for compatibility with existing selectors
      const expectedUnitDuration = cycleTimeMs
        ? moment.duration(cycleTimeMs).format('HH:mm:ss.SSS', { trim: false })
        : null;

      // Synthesize an activity set from labor ticket data
      return {
        activitySetRef: null, // Not applicable in NATS mode
        machineRef: machine?.machineRef,
        closedAt: isOpen ? null : currentLaborTicket.clockOut,
        workOrderOperationRef:
          currentLaborTicket.workOrderOperation?.workOrderOperationRef,
        workOrderId: currentLaborTicket.workOrderId,
        jobId: currentLaborTicket.workOrderId,
        partCountMultiplier: currentWorkOrderOp?.quantityPerPart || 1,
        actualParts: currentWorkOrderOp?.quantityPerPart || 1,
        expectedUnitDuration,
      };
    }

    if (!latestActivitySetRef) {
      return defaultLatestActivitySet;
    }
    return _get(
      activitySetsByRef,
      latestActivitySetRef,
      defaultLatestActivitySet
    );
  }
);

export { getLatestActivitySet };
